<button
  class="palantir-toggle"
  role="switch"
  type="button"
  [disabled]="disabled()"
  [attr.id]="uniqueId"
  [attr.aria-checked]="checked()"
  [attr.aria-disabled]="disabled() ? 'true' : null"
  (click)="toggle()"
  [class.palantir-toggle--disabled]="disabled()"
  [class.palantir-toggle--selected]="checked()"
  [class.palantir-toggle--unselected]="!checked() && !disabled()"
>
  <div class="palantir-toggle__icon"></div>
</button>

@if (label()) {
  <label
    [for]="uniqueId"
    (click)="$event.stopPropagation()"
    (keypress)="$event.stopPropagation()"
    class="palantir-toggle__label"
    [class.palantir-toggle__label--disabled]="disabled()"
  >
    <palantir-text>{{ label() }}</palantir-text>
  </label>
}
